import Component from '../site/Component';

/**
 * Component for tabbed content
 */
export default class Toggle extends Component {
  /**
   * Start the component (called when Component is instantiated)
   */
  start() {
    this.toggleClass();
  }

  toggleClass() {
    const elementTarget = this.element.dataset.toggleTarget;
    const elementsToToggle = document
      .querySelectorAll(`[data-toggle-element="${elementTarget}"]`);
    const elementBlock = this.element.dataset.toggleBlock;
    const toggleClass = `${elementBlock}--active`;

    this.element.addEventListener('click', (e) => {
      e.preventDefault();
      Array.prototype.forEach.call(elementsToToggle, (toggleElement) => {
        toggleElement.classList.toggle(toggleClass);
        if (!toggleElement.classList.contains(toggleClass)) {
          toggleElement.setAttribute('aria-hidden', 'true');
          this.element.setAttribute('aria-expanded', 'false');
        } else {
          toggleElement.setAttribute('aria-hidden', 'false');
          this.element.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }
}
